<div class="payment-form-container">
  <div class="form-header">
    <h2 style="color: #fff;">
      <i class="fas fa-money-bill-wave"></i> {{ 'MENU.DASHBOARD.add_new_payment' | translate }}
    </h2>
  </div>
  
  <div class="form-body">
    <form (ngSubmit)="onSubmit()" #paymentForm="ngForm" novalidate>
      <!-- Payment Information Section -->
      <div class="form-section">
        <div class="section-title">
          <i class="fas fa-info-circle"></i> {{ 'MENU.DASHBOARD.payment_information' | translate }}
        </div>
        
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="payment_method" class="form-label required">
              {{ 'MENU.DASHBOARD.payment_method' | translate }}
            </label>
            <input 
              type="text" 
              class="form-control" 
              [class.is-invalid]="paymentForm.submitted && paymentMethodInput.invalid"
              [class.is-valid]="paymentMethodInput.valid"
              id="payment_method" 
              name="payment_method" 
              #paymentMethodInput="ngModel"
              [(ngModel)]="paymentData.payment_method"
              [placeholder]="'MENU.DASHBOARD.enter_payment_method' | translate" 
              required
              minlength="2"
              maxlength="100">
            
            <!-- Validation Messages -->
            <div *ngIf="paymentForm.submitted && paymentMethodInput.invalid" class="invalid-feedback">
              <div *ngIf="paymentMethodInput.errors?.['required']">
                {{ 'MENU.DASHBOARD.payment_method_required' | translate }}
              </div>
              <div *ngIf="paymentMethodInput.errors?.['minlength']">
                {{ 'MENU.DASHBOARD.payment_method_min_length' | translate }}
              </div>
              <div *ngIf="paymentMethodInput.errors?.['maxlength']">
                {{ 'MENU.DASHBOARD.payment_method_max_length' | translate }}
              </div>
            </div>
          </div>

          <div class="col-md-6 mb-3">
  <label for="paid_amount" class="form-label required">
    {{ 'MENU.DASHBOARD.paid_amount' | translate }}
  </label>

  <input
    type="number"
    class="form-control"
    id="paid_amount"
    name="paid_amount"
    [(ngModel)]="paymentData.paid_amount"
    #paidAmountInput="ngModel"
    [class.is-invalid]="paymentForm.submitted && paidAmountInput.invalid"
    min="1"
    required
    placeholder="{{ 'MENU.DASHBOARD.enter_paid_amount' | translate }}"
  />

  <div *ngIf="paymentForm.submitted && paidAmountInput.invalid" class="invalid-feedback">
    {{ 'MENU.DASHBOARD.paid_amount_required' | translate }}
  </div>
</div>

          
<!-- 

<div class="col-md-6 mb-3">
  <label for="payment_date" class="form-label required">
    {{ 'MENU.DASHBOARD.payment_date' | translate }}
  </label>

  <input
    type="date"
    class="form-control"
    id="payment_date"
    name="payment_date"
    [(ngModel)]="paymentData.payment_date"
    #paymentDateInput="ngModel"
    [class.is-invalid]="paymentForm.submitted && paymentDateInput.invalid"
    required
  />

  <div *ngIf="paymentForm.submitted && paymentDateInput.invalid" class="invalid-feedback">
    {{ 'MENU.DASHBOARD.payment_date_required' | translate }}
  </div>
</div>
 -->



          <div class="col-md-6 mb-3">
            <label for="account_number" class="form-label required">
              {{ 'MENU.DASHBOARD.account_number' | translate }}
            </label>
            <input 
              type="text" 
              class="form-control" 
              [class.is-invalid]="paymentForm.submitted && accountNumberInput.invalid"
              [class.is-valid]="accountNumberInput.valid"
              id="account_number" 
              name="account_number" 
              #accountNumberInput="ngModel"
              [(ngModel)]="paymentData.account_number"
              [placeholder]="'MENU.DASHBOARD.enter_account_number' | translate" 
              minlength="5"
              maxlength="50"
              pattern="[0-9]*">
            
            <!-- Validation Messages -->
            <div *ngIf="paymentForm.submitted && accountNumberInput.invalid" class="invalid-feedback">
              <!-- <div *ngIf="accountNumberInput.errors?.['required']">
                {{ 'MENU.DASHBOARD.account_number_required' | translate }}
              </div> -->
              <div *ngIf="accountNumberInput.errors?.['minlength']">
                {{ 'MENU.DASHBOARD.account_number_min_length' | translate }}
              </div>
              <div *ngIf="accountNumberInput.errors?.['maxlength']">
                {{ 'MENU.DASHBOARD.account_number_max_length' | translate }}
              </div>
              <div *ngIf="accountNumberInput.errors?.['pattern']">
                {{ 'MENU.DASHBOARD.account_number_pattern' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Transfer Image Section -->
      <div class="form-section">
        <div class="section-title">
          <i class="fas fa-file-image"></i> {{ 'MENU.DASHBOARD.transfer_image' | translate }}
        </div>
        
        <div 
          class="file-upload-area" 
          id="uploadArea"
          (click)="triggerFileInput()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <i class="fas fa-cloud-upload-alt"></i>
          <p>{{ 'MENU.DASHBOARD.click_or_drag_image' | translate }}</p>
          <p class="text-muted">{{ 'MENU.DASHBOARD.max_file_size' | translate }}</p>
          <input 
            type="file" 
            id="transfer_file" 
            name="transfer_file" 
              accept="image/*,application/pdf"
            style="display: none;"
            (change)="onFileSelected($event)">
        </div>
        
        <!-- File Validation Message -->
        <!-- <div *ngIf="paymentForm.submitted && !selectedFile" class="invalid-feedback d-block">
          {{ 'MENU.DASHBOARD.transfer_image_required' | translate }}
        </div> -->

        <!-- File Type & Size Validation -->
        <div *ngIf="fileError" class="alert alert-danger mt-2">
          {{ fileError }}
        </div>


             <div class="file-preview" *ngIf="!imagePreview && selectedFile">
  <i class="fas fa-file-pdf text-danger fa-3x"></i>
  <div class="file-info">
    {{ fileName }} | {{ fileSize }}
  </div>
</div>

        
        <div class="file-preview" *ngIf="imagePreview">
          <img [src]="imagePreview" alt="Image preview" class="preview-image">
          <div class="file-info">
            {{ 'MENU.DASHBOARD.file_name' | translate }}: {{ fileName }} | {{ 'MENU.DASHBOARD.size' | translate }}: {{ fileSize }}
          </div>
          <button 
            type="button" 
            class="btn btn-sm btn-outline-danger mt-2" 
            (click)="removeImage()">
            <i class="fas fa-times"></i> {{ 'MENU.DASHBOARD.remove_image' | translate }}
          </button>
        </div>
      </div>

      <!-- Form Level Errors -->
      <div *ngIf="formError" class="alert alert-danger">
        {{ formError }}
      </div>
      
      <!-- Submit Button -->
      <button 
        type="submit" 
        class="btn btn-submit"
        [disabled]="isLoading">
        <i class="fas fa-paper-plane"></i> 
        {{ isLoading ? ('MENU.DASHBOARD.sending' | translate) : ('MENU.DASHBOARD.add_payment' | translate) }}
      </button>
      
      <!-- <div class="form-footer">
        <p>
          {{ 'MENU.DASHBOARD.all_fields_required' | translate }} 
          <span style="color: #e74c3c;">*</span> 
          {{ 'MENU.DASHBOARD.are_required' | translate }}
        </p>
      </div> -->
    </form>
  </div>
</div>